import { t } from "./i18n";

// Une note pleine ("10.00" venant d'une colonne DECIMAL, ou "10.0" via toFixed(1)) doit
// s'afficher "10" — seules les notes réellement fractionnaires ("8.5") gardent une décimale.
export const formatScore = (value: number | string | null | undefined): string => {
  const n = Number(value || 0);
  return Number.isInteger(n) ? String(n) : n.toFixed(1);
};

// Repère relatif ("Aujourd'hui" / "Demain" / "dans 4j") affiché À CÔTÉ de la date absolue déjà
// présente sur les cartes Passion/Power/Move, jamais à sa place — même logique que Vibes
// ("dans 4j.") mais toujours en complément d'une vraie date exacte. null pour une date déjà
// passée : une sortie qui a déjà eu lieu n'a pas de compte à rebours qui ait un sens.
export const relativeDayLabel = (dateStr: string | null | undefined, lang: string): string | null => {
  if (!dateStr) return null;
  const startOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const diffDays = Math.round((startOfDay(new Date(dateStr)) - startOfDay(new Date())) / 86400000);
  if (diffDays < 0) return null;
  if (diffDays === 0) return t(lang, "msg_today");
  if (diffDays === 1) return t(lang, "date_tomorrow");
  return t(lang, "date_in_days").replace("{n}", String(diffDays));
};
